const config = {
  version: '1.0',
  type: 'prod',
  apiUri: 'https://api.veventy.com/v1/',
  lpUri: 'https://veventy.com',
  socket: 'wss://ppocghwfo5.execute-api.eu-central-1.amazonaws.com/production',
  fbOauth: '1311461896041160',
  pusher: 'bf6a2cf8bf3382f90a84',
  tokbox: '46995414',
  stripe: 'pk_live_51I6LZPHcrUHKAWVTbuK7VBoo4Kng1fKJkmDR5MiPw5QRYwFa4TdABcPnENpBZawPUFsTlusKvUKc1vUr6WrAwW4Q006tUAAhJk',
  intercom: 'bc8d3vgo',
  expo: false,
  sales: true,
  meet: false,
  tutorials: false,
  paidTickets: false,
  forms: false,
  tickets: false
};

export default config;
